import React, { useRef, useEffect } from 'react';
import * as d3 from 'd3';

const LineChart = ({ data }) => {
    const svgRef = useRef();

    useEffect(() => {
        if (!data || data.length === 0) return;

        const margin = { top: 40, right: 30, bottom: 50, left: 60 };
        const width = 900 - margin.left - margin.right;
        const height = 400 - margin.top - margin.bottom;

        const svg = d3.select(svgRef.current);
        svg.selectAll("*").remove();

        const g = svg
            .attr("viewBox", `0 0 ${width + margin.left + margin.right} ${height + margin.top + margin.bottom}`)
            .append("g")
            .attr("transform", `translate(${margin.left},${margin.top})`);

        const x = d3.scaleTime()
            .domain(d3.extent(data, d => d.date))
            .range([0, width]);

        const y = d3.scaleLinear()
            .domain([0, d3.max(data, d => d.value) * 1.1])
            .range([height, 0]);

        g.append("g")
            .attr("transform", `translate(0,${height})`)
            .call(d3.axisBottom(x).ticks(10).tickSizeOuter(0))
            .attr("color", "#666");

        g.append("g")
            .call(d3.axisLeft(y).ticks(5).tickFormat(d3.format(".0s")))
            .call(g => g.select(".domain").remove()) 
            .call(g => g.selectAll(".tick line").clone() 
                .attr("x2", width)
                .attr("stroke-opacity", 0.1))
            .attr("color", "#666");

        // Línea
        const line = d3.line()
            .x(d => x(d.date))
            .y(d => y(d.value))
            .curve(d3.curveMonotoneX); 

        g.append("path")
            .datum(data)
            .attr("fill", "none")
            .attr("stroke", "#4e73df")
            .attr("stroke-width", 2)
            .attr("d", line);

        svg.append("text")
            .attr("x", margin.left)
            .attr("y", 20)
            .attr("text-anchor", "start")
            .style("font-size", "16px")
            .style("font-weight", "bold")
            .style("fill", "#333")
            .text("Grafica de cotizaciones");

    }, [data]);

    return (
        <div style={{ width: '100%', overflow: 'hidden' }}>
            <svg ref={svgRef}></svg>
        </div>
    );
};

export default LineChart;
